import * as c from '../constants/grades';
import { apiAction } from './api';
import { dismiss, modal } from './notification';

export const chooseAnswer = (questionId, answerId) =>
  apiAction(
    [
      c.GRADE_SUBMIT_ANSWER,
      c.GRADE_SUBMIT_ANSWER_SUCCESS,
      c.GRADE_SUBMIT_ANSWER_FAILURE,
    ],
    (api) => api.saveQuestionResponse(questionId, answerId),
    {
      questionId,
      answerId,
    }
  );

export const beginExercise = (code) =>
  apiAction(
    [c.GRADE_BEGIN, c.GRADE_BEGIN_SUCCESS, c.GRADE_BEGIN_FAILURE],
    (api) => api.beginExercise(code),
    {
      code,
    }
  );

export const finishExercise = (code) =>
  apiAction(
    [c.GRADE_FINISH, c.GRADE_FINISH_SUCCESS, c.GRADE_FINISH_FAILURE],
    (api) => api.finishExercise(code),
    {
      code,
    }
  );

export const markExerciseComplete = () => (dispatch, getState) => {
  const {
    research: { selectedPage },
  } = getState();
  dispatch(
    apiAction(
      [
        c.GRADE_MARK_COMPLETE,
        c.GRADE_MARK_COMPLETE_SUCCESS,
        c.GRADE_MARK_COMPLETE_FAILURE,
      ],
      (api) => api.markExerciseComplete(selectedPage),
      {
        selectedPage,
      }
    )
  );
};

export const retakeExercise = (code, retakesAllowed) => (dispatch) => {
  const buttons = [
    {
      label: 'Cancel',
      variant: 'light',
      action: (id) => dispatch(dismiss(id)),
    },
    {
      label: 'Retake Now',
      variant: 'primary',
      action: (id) => {
        dispatch(dismiss(id));
        dispatch(
          apiAction(
            [c.GRADE_RETAKE, c.GRADE_RETAKE_SUCCESS, c.GRADE_RETAKE_FAILURE],
            (api) => api.retakeExercise(code),
            {
              code,
            }
          )
        );
      },
    },
  ];

  let message;
  if (retakesAllowed === 1) {
    message =
      'You can try this exercise one more time.  The questions will be different and the score you receive on the retake is your final score.';
  } else {
    message = `You can try this exercise ${retakesAllowed} more times. The questions will be different and the score you receive on your last retake is your final score.`;
  }

  dispatch(modal('Retake Exercise', message, buttons, { backdrop: true }));
};

export const loadGradebook = (grades) => ({
  type: c.GRADE_LOAD_GRADEBOOK,
  grades,
});

export const loadGradeResponses = (responses) => ({
  type: c.GRADE_LOAD_GRADE_RESPONSES,
  responses,
});

export const loadGrades = (data) => (dispatch) => {
  let gradebook = data.map((item) => ({
    id: item.id,
    exerciseCode: item.exerciseCode,
    score: item.score,
    timeOnTask: item.timeOnTask,
    attempts: item.attempts,
    isComplete: item.isComplete,
    retakesAllowed: item.retakesAllowed,
  }));

  dispatch(loadGradebook(gradebook));

  let responses = data
    .map((item) => {
      return item.responses.map((resp) => ({
        id: resp.id,
        questionId: resp.questionId,
        answerId: resp.answer ? resp.answer.id : 0,
        answerText:
          resp.question.questionType === 3
            ? resp.answer + ''
            : resp.answer
            ? resp.answer.description
            : '',
        correctAnswerId: resp.correctAnswer ? resp.correctAnswer.id : 0,
        correctAnswerText:
          resp.question.questionType === 3
            ? resp.correctAnswer + ''
            : resp.correctAnswer
            ? resp.correctAnswer.description
            : '',
        correctAnswerExplanation: resp?.correctAnswerExplanation,
        isAnswered: resp.isAnswered,
        isCorrect: resp.isCorrect,
        score: resp.score,
        attempts: resp.attempts,
        checking: false,
        exerciseCode: item.exerciseCode,
      }));
    })
    .reduce((arr, curr) => {
      return [...arr, ...curr];
    }, []);

  dispatch(loadGradeResponses(responses));
};
